export function encodeBase64url(bytes: Uint8Array) {
  const alphabet =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
  let bits = 0;
  let accumulator = 0;
  const output = [];
  let index = 0;
  while (index < bytes.length || bits > 0) {
    if (bits < 6 && index < bytes.length) {
      accumulator = (accumulator | bytes[index++]) << 8;
      bits += 8;
    }
    bits -= 6;
    output.push(accumulator >> (bits + 8));
  }
  return output.map((v) => alphabet[v & 0x3f]).join('');
}

export function makeCodeVerifier() {
  // PKCE:
  // https://datatracker.ietf.org/doc/html/rfc7636

  // See: https://developers.google.com/identity/protocols/oauth2/native-app#step1-code-verifier
  const codeVerifier = encodeBase64url(
    crypto.getRandomValues(new Uint8Array(48)),
  );
  localStorage.setItem('code_verifier', codeVerifier);
  return codeVerifier;
}

export function getCodeVerifier() {
  return localStorage.getItem('code_verifier');
}

export async function computeCodeChallenge(codeVerifier: string) {
  return encodeBase64url(
    new Uint8Array(
      await crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(codeVerifier),
      ),
    ),
  );
}
